import FileManager from '@modules/files/FileManager';
import { Box, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const TalentFiles = () => {
    const { id } = useParams<{ id: string }>();

    if (!id) {
        return null;
    }

    return (
        <Paper sx={{ borderRadius: 5, flex: 1, display: 'flex', flexDirection: 'column' }}>
            <FileManager talentId={id} />
        </Paper>
    );
};

export default TalentFiles;
